import Global from "./global/Global";
import AddressAutocomplete from "./address/AddressAutocomplete";
import Blog from "./global/Blog";
import Event from "./global/Event";
import SSRHeroModule from "./global/SSRHeroModule";

export const components = {
    'body': Global,
    '.geolocation': AddressAutocomplete,
    '.blog-content-page': Blog,
    '.event-content-page': Event,
    '#hero-element.ssr': SSRHeroModule,
};
